import axios from "axios";
import Swal from "sweetalert2";
import store from "@/store";

// 1. Detectamos la URL base. 
// Si existe la variable en el .env la usa; si no, usa el localhost por defecto.
const BASE_URL_API = process.env.VUE_APP_API_URL || "https://sigaf.tamep.bo/";

const api = axios.create({
  baseURL: BASE_URL_API,
});

// --- INTERCEPTOR DE PETICIÓN ---
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access");

  if (token && token !== "undefined" && token !== "null") {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }

  // No activar el loader global si es la petición de login o si se pide silencioso
  if (!config.url.includes('token') && !config.url.includes('login') && !config.silentLoader) {
    store.commit("START_LOADING");
  }
  
  return config;
}, (error) => {
  store.commit("STOP_LOADING");
  return Promise.reject(error);
});

// --- INTERCEPTOR DE RESPUESTA ---
api.interceptors.response.use(
  (response) => {
    if (!response.config.url.includes('token') && !response.config.url.includes('login') && !response.config.silentLoader) {
      store.commit("STOP_LOADING");
    }
    return response;
  },
  async (error) => {
    if (error.config && !error.config.url.includes('token') && !error.config.url.includes('login') && !error.config.silentLoader) {
      store.commit("STOP_LOADING");
    }
    const originalRequest = error.config;

    if (!originalRequest) {
      return Promise.reject(error);
    }

    const esPeticionAuth = originalRequest.url?.includes('login') || 
                           originalRequest.url?.includes('token');

    // Manejo de expiración de token (Solo para peticiones protegidas, NO para login/token)
    if (error.response?.status === 401 && !originalRequest._retry && !esPeticionAuth) {
      originalRequest._retry = true;

      const refresh = localStorage.getItem("refresh");

      if (!refresh || refresh === "undefined") {
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");
        localStorage.removeItem("user");
        if (window.location.pathname !== "/signin") {
          window.location.href = "/signin";
        }
        return Promise.reject(error);
      }

      try {
        const response = await axios.post(
          `${BASE_URL_API}token/refresh/`, 
          { refresh }
        );

        const nuevoAccess = response.data.access;
        localStorage.setItem("access", nuevoAccess);

        originalRequest.headers.Authorization = `Bearer ${nuevoAccess}`;

        return api(originalRequest);

      } catch (err) {
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");
        localStorage.removeItem("user");
        if (window.location.pathname !== "/signin") {
          window.location.href = "/signin";
        }
        return Promise.reject(err);
      }
    }

    // --- MANEJO GLOBAL DE ERRORES (Excepto 401 que ya se procesó o ignorados explícitamente) ---
    if (error.response && error.response.status !== 401 && !originalRequest.silentError) {
      let mensajeError = "Ocurrió un error inesperado en el servidor.";
      
      if (error.response.data && typeof error.response.data === 'object' && !(error.response.data instanceof Blob)) {
        // Intentar extraer el primer mensaje útil del diccionario de Django REST Framework
        const valores = Object.values(error.response.data).flat();
        if (valores.length > 0 && typeof valores[0] === 'string') {
          mensajeError = valores.join(" ");
        }
      } else if (error.message) {
        mensajeError = error.message;
      }
      
      Swal.fire({
        icon: 'error',
        title: 'Error ' + (error.response.status || ''),
        text: mensajeError,
        confirmButtonColor: '#f5365c'
      });
    } else if (!error.response && !originalRequest.silentError) {
      // Error de red (Network Error)
      Swal.fire({
        icon: 'error',
        title: 'Error de Red',
        text: 'No se pudo conectar con el servidor. Verifique su conexión.',
        confirmButtonColor: '#f5365c'
      });
    }

    return Promise.reject(error);
  }
);

export default api;